import type { SVGProps } from 'react';

export function KeyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 15.6A6.6 6.6 0 1 0 8.4 9c0 .701.109 1.38.311 2.014l-6.048 6.049a.9.9 0 0 0-.263.637v3c0 .499.401.9.9.9h3c.499 0 .9-.401.9-.9v-1.5h1.5c.499 0 .9-.401.9-.9v-1.5h1.5c.24 0 .469-.094.638-.262l1.248-1.25A6.6 6.6 0 0 0 15 15.6M16.5 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
    </svg>
  );
}
